import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useArtists } from '../../hooks/useArtists';

const WritersPage = () => {
  const { artists } = useArtists();
  const writers = artists.filter(a => a.type === 'writer');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-8 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold mb-6">Writers</h1>
          <p className="text-xl text-gray-700 max-w-3xl leading-relaxed">
            저희 작가들은 독자와 소통하는 매력적인 서사를 창조합니다. 브랜드 스토리텔링부터 전문 콘텐츠까지, 영감을 주고 참여를 이끌어내는 글을 제공합니다.
          </p>
        </div>
      </section>

      {/* Artists Grid */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {writers.map((artist) => (
              <Link key={artist.id} to={`/artist/${artist.slug}`} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-5 aspect-[4/5]">
                  <img
                    src={artist.image}
                    alt={artist.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                    <div>
                      <p className="text-white text-sm font-medium mb-2">포트폴리오 보기</p>
                      <i className="ri-arrow-right-line text-white text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-2">{artist.name}</h3>
                <p className="text-sm text-gray-600">{artist.specialty}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WritersPage;
